import React, { useEffect, useState } from 'react';
import { BOTTOM_INDENTS, COLORS, TOP_INDENTS } from '@constants';
import { useStore } from '@hooks';
import { Icon, Table, Tooltip, Typography } from '@ui';
import { fileDownload } from '@utils';
import { Col, notification } from 'antd';
import DownloadModal from '../DownloadModal';
import { getColumns } from './constants/columns';
import { StyledDescription } from './styled';

const Statements = () => {
    const store = useStore();
    const [modal, setModal] = useState(false);
    const [params, setParams] = useState({});
    const [loading, setLoading] = useState(true);
    const { statements, statementsMeta, getInvoices, downloadPDFInvoices } = store.invoicesStore;

    useEffect(() => {
        (async () => {
            await getInvoices('statements');
            setLoading(false);
        })();
    }, []);

    const onDownloadPDF = async (params) => {
        try {
            setLoading(true);
            const url = await downloadPDFInvoices({ ...params, transaction_type: 'statements' });

            if (!url) {
                setLoading(false);
                setParams(params);
                return setModal(true);
            }

            fileDownload(url, () => setLoading(false));
        } catch (_) {
            notification.error({
                message: 'Something went wrong'
            });
        }
    };

    const onTableChange = async (pagination) => {
        setLoading(true);

        const params = { page: pagination.current, perPage: pagination.pageSize };

        await getInvoices('statements', params);

        setLoading(false);
    };

    const toolTipText = (
        <React.Fragment>
            <span data-e2e='invoices_statements-refund-note-tooltip_text'>
                <Typography.Text style={BOTTOM_INDENTS.S} color={COLORS.$white}>
                    Your Performance tab and Statements may differ.
                </Typography.Text>
                <Typography.Text style={BOTTOM_INDENTS.S} type='badgeMedium' color={COLORS.$white}>
                    Performance tab:
                </Typography.Text>
                <Typography.Text style={BOTTOM_INDENTS.S} color={COLORS.$white}>
                    Refunds, even those occurring weeks or months later, are applied to the original transaction date.
                    This allows you to accurately track ROAS and other performance metrics.
                </Typography.Text>
                <Typography.Text style={BOTTOM_INDENTS.S} type='badgeMedium' color={COLORS.$white}>
                    Statements:
                </Typography.Text>
                <Typography.Text color={COLORS.$white}>
                    Refunds are applied on the actual date they occur, even if they’re in a subsequent month. Since
                    monthly statements cannot be changed once issued, refunds processed in a later month will only
                    appear in that month’s statement.
                </Typography.Text>
            </span>
        </React.Fragment>
    );

    return (
        <Col>
            {modal ? (
                <DownloadModal
                    params={params}
                    setIsModalOpen={setModal}
                    type='Statements'
                    downloadPDFInvoices={downloadPDFInvoices}
                />
            ) : null}
            <StyledDescription gap={12} align='center'>
                <Typography.Text
                    color={COLORS.$gray60Black}
                    type='body2'
                    data-e2e='invoices_statements-refund-note_text'
                >
                    Refunds may differ between your Performance tab and monthly Statements.
                </Typography.Text>
                <Tooltip title={toolTipText} trigger='hover' placement='right'>
                    <Icon.QuestionCircleIcon width='24px' height='24px' color={COLORS.$info} />
                </Tooltip>
            </StyledDescription>
            <Table
                loading={loading}
                dataSource={statements}
                columns={getColumns(onDownloadPDF)}
                rowKey={(record, index) => `${record.month_start}-${index}`}
                onChange={onTableChange}
                pagination={{
                    total: statementsMeta?.total,
                    totalPages: statementsMeta?.totalPages,
                    pageSize: statementsMeta?.perPage,
                    current: statementsMeta?.page
                }}
                style={TOP_INDENTS.M}
            />
        </Col>
    );
};

export default Statements;
